import config from '../../config';

export const controlChatbotVisibility = (chatbotNode, currentPathname) => {
  const disallowedPathnames = config.chatbot.disallowedPathnames;
  const isDisallowed = disallowedPathnames.includes(currentPathname);

  chatbotNode.style.display = isDisallowed ? 'none' : 'block';
};
